import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const store = new createStore({
  plugins: [createPersistedState({ storage: window.localStorage })],
  state() {
    return {
      userAlert: {
        visible: false,
        alert_type: '',
        message: '',
      },
      coreThingsUser: {
        is_user: false,
        email: null,
      },
      account: {
        name: null,
        role: null,
      },
      project: {
        name: null,
        role: null,
      },
      user: {
        email: null,
      },
    };
  },
  mutations: {
    updateUserAlert(state, payload) {
      state.userAlert.visible = payload.visible;
      state.userAlert.alert_type = payload.alert_type;
      state.userAlert.message = payload.message;
    },
    updateUserAccount(state, payload) {
      state.account.name = payload.account_name;
      state.account.role = payload.account_role;
    },
    updateUserProject(state, payload) {
      state.project.name = payload.project_name;
      state.project.role = payload.project_role;
    },
    updateCoreThingsUser(state, payload) {
      state.coreThingsUser.is_user = payload.is_user;
    },
    updateUser(state, payload) {
      state.user.email = payload.email;
    },
  },
});

export default store;
